import { useState } from 'react';

import { Entity } from '@/models/entity';
import { useEntityGroups } from '@/models/entityGroup';
import { GROUPS_PER_PAGE, GroupsTable } from '@/routes/SettingsBeta/components/GroupsTable';

export const GroupsSection = ({ entity }: { entity: Entity }) => {
  const [page, setPage] = useState(1);

  const {
    data: { entityGroups, meta } = { entityGroups: [] },
    isLoading,
    isPlaceholderData,
    isError,
  } = useEntityGroups(
    { limit: GROUPS_PER_PAGE, offset: (page - 1) * GROUPS_PER_PAGE, entityId: entity.id },
    { keepPreviousData: true }
  );

  return (
    <GroupsTable
      entityGroups={entityGroups}
      isLoading={isLoading || isPlaceholderData}
      isError={isError}
      page={page}
      onPageChange={setPage}
      count={meta?.count}
    />
  );
};
